import { getDurationSecondsStr } from '@iotv/datamodel-core';
import ApiGateway from '../../aws/api-gateway/ApiGateway';
const { REACT_APP_DEBUG } = process.env;
const debug = REACT_APP_DEBUG && false;
export const getBucketedReadings = async (paramsIn) => {
    let res = { err: null, data: null, meta: undefined, timings: {} };
    const path = '/entity/bucketedReadings';
    const t0 = Date.now();
    const response = (await ApiGateway.post(path, paramsIn, 'ConsumerApi'));
    debug && console.log(`getBucketedReadings (DAO) API in ${getDurationSecondsStr(t0)}`, paramsIn, { response });
    const dashboardDataResponse = response;
    if (dashboardDataResponse.data) {
        res = dashboardDataResponse;
    }
    else if (response.err) {
        res.err = response.err;
    }
    else {
        console.warn(`Unexpected result`, response);
    }
    return res;
};
